/** Remaining seconds until SMS OTP expiry (from code_expires_at). */
export const getMfaCodeSecondsLeft = (codeExpiresAt) => {
  if (!codeExpiresAt) return 0;
  const end = new Date(codeExpiresAt).getTime();
  if (!Number.isFinite(end)) return 0;
  return Math.max(0, Math.ceil((end - Date.now()) / 1000));
};

/** Format seconds as m:ss or mm:ss */
export const formatMfaCountdown = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const mins = Math.floor(s / 60);
  const secs = s % 60;
  return `${mins}:${String(secs).padStart(2, "0")}`;
};
